var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 1.01367V3.76737C7.33366 4.14073 7.33366 4.32742 7.40632 4.47003C7.47024 4.59547 7.57222 4.69745 7.69767 4.76137C7.84027 4.83403 8.02696 4.83403 8.40033 4.83403H11.154M7.33366 10.834H3.33366M8.66699 8.16732H3.33366M11.3337 6.15947V10.9673C11.3337 12.0874 11.3337 12.6475 11.1157 13.0753C10.9239 13.4516 10.618 13.7576 10.2416 13.9493C9.81382 14.1673 9.25376 14.1673 8.13366 14.1673H3.86699C2.74689 14.1673 2.18683 14.1673 1.75901 13.9493C1.38269 13.7576 1.07673 13.4516 0.884979 13.0753C0.666992 12.6475 0.666992 12.0874 0.666992 10.9673V4.03398C0.666992 2.91388 0.666992 2.35383 0.884979 1.926C1.07673 1.54968 1.38269 1.24372 1.75901 1.05197C2.18683 0.833984 2.74689 0.833984 3.86699 0.833984H6.00818C6.49736 0.833984 6.74195 0.833984 6.97212 0.889245C7.17619 0.938238 7.37128 1.01905 7.55023 1.1287C7.75206 1.25239 7.92501 1.42534 8.27092 1.77124L10.3964 3.89673C10.7423 4.24263 10.9153 4.41558 11.0389 4.61741C11.1486 4.79636 11.2294 4.99145 11.2784 5.19552C11.3337 5.4257 11.3337 5.67029 11.3337 6.15947Z",
    stroke: "white",
    strokeOpacity: 0.95,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.2920e6f4fad223599ad0f47868580f59.svg";
export { ForwardRef as ReactComponent };